export default __webpack_public_path__ + "static/media/01_Login.8a1187b3.png";